import Make from './make'

const make = Make('sharing/')

interface CreateSharingLink {
  sharingPermission: 'public' | 'private'
  originUrl: string
}

export const createSharingLink = async (
  data: CreateSharingLink,
): Promise<any> => {
  const req = await make.post({
    endpoint: 'create-sharing-link',
    data: {
      ...data,
    },
  })

  if (!req.success) {
    return false
  }

  return req?.res?.data || null
}

interface UpdateSharingLink {
  originUrl: string
  shareLinkID: string
  sharingPermission: 'public' | 'private' | 'off'
}

export const updateSharingLink = async (
  data: UpdateSharingLink,
): Promise<any> => {
  const req = await make.post({
    endpoint: 'update-sharing-link',
    data: {
      ...data,
    },
  })

  if (!req.success) {
    return false
  }

  return true
}

interface GetSharingLinkData {
  shareLinkID: string
}

export const getSharingLinkData = async (
  data: GetSharingLinkData,
): Promise<any> => {
  const { shareLinkID } = data
  const req = await make.get({
    endpoint: `get-sharing-link-data/${shareLinkID}`,
  })

  if (!req.success) {
    return false
  }

  return req?.res?.data || null
}

interface ShareSharingLink {
  shareLinkID: string
  shareEmails: string[]
  note?: string
  pageData: {
    anomDate: string
    metric: string
    siteSection: string
  }
}

export const shareSharingLink = async (
  data: ShareSharingLink,
): Promise<any> => {
  const req = await make.post({
    endpoint: 'share-sharing-link',
    data: {
      ...data,
    },
  })

  if (!req.success) {
    return false
  }

  return true
}

interface GetSharingLinkRedirect {
  shareLinkID: string
}

export const getSharingLinkRedirect = async (
  data: GetSharingLinkRedirect,
): Promise<any> => {
  const { shareLinkID } = data
  const req = await make.get({
    endpoint: `get-sharing-link-redirect/${shareLinkID}`,
  })

  if (!req.success) {
    return false
  }

  return req?.res?.data || null
}
